import {appContainer} from "../../contexts/app";
import Resource from "../resource";
import {Map, List} from "immutable";

export default (userService, appContainer) => {
  // const service = app.service('api/users');
  // // Lengthen the timeout to allow for image uploads
  // service.timeout = 10000;
  let userResource = Resource(
    userService,
    {
      first_name: "",
      last_name: "",
      full_name: "",
      email: "",
      permissions: Map({
        resources: Map({
          buildings: List(),
          markerTypeCategories: List()
        }),
        edit: Map({
          resources: false,
          users: false,
          account: false
        }),
        groups: List()
      }),
      image: Map({
        name: "",
        path: "",
        key: ""
      }),
      trainingTutorials: List()
    },
    {
      getPermissions() {
        return appContainer.state.get("permissions").find(permission => permission.user_id === this._id);
      }
    }
  );

  userResource.getCurrentUser = () => {
    // Passing null to the .get() method on users service will
    // return the user according to the user id in the token
    // Pass isCurrentUser because this is the call that actually
    // initally loads currentUser into state and the setCurrentUser
    // hook cannot check against it if it doesnt already exist
    return userService.get(null, {isCurrentUser: true});
  };

  return userResource;
};

// If we are working on the currentUser, put it in proper
// place in state also. It is also set his/her permissions.
// This is the only user with permissions attached directly
// to it, unlike any other (not current) user.
export const setCurrentUser = async context => {
  const currentUserId = appContainer.state.getIn(["currentUser", "_id"]);
  if (context.params.isCurrentUser || context.id === currentUserId) {
    const {data: permission} = await context.app
      .service("api/permissions")
      .find({query: {user_id: context.result._id, $limit: 1}});
    // Beacause this is a .find() and not a .get() it returns a Map
    // with the item at prop _id, even though it is
    // only one, instead of just the item. Get
    // the first() item which will be the resource
    const perms = permission.first().get("permissions");
    const user = context.result.set("permissions", perms);
    appContainer.set("currentUser", user);
  }
};



// WEBPACK FOOTER //
// ./src/feathers/users/users.js